<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="2">
          <el-button
            class="goBack"
            style="width:150px"
            @click="goback()"
          >返回上一级</el-button>
        </el-col>
        <!-- <el-col :span="2" :offset="20">
          <el-button style="width:100px"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col> -->
      </el-row>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table v-loading="loading" :data="scope.row.tbEventMemberList" border stripe>
              <el-table-column prop="member" label="队员名"></el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scoped">
                  <div v-if="scoped.row.state == 0">待审批</div>
                  <div v-if="scoped.row.state == 1">已入队</div>
                </template>
              </el-table-column>
              <el-table-column prop="jointime" label="加入时间"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="groupName" label="团队名"></el-table-column>
        <!-- <el-table-column label="头像">
           <template slot-scope="scope">
             <img style="width:100px;height:100px" :src="scope.row.email" alt="">
          </template>
        </el-table-column> -->
        <el-table-column label="队徽">
           <template slot-scope="scope">
             <img
             style="width:100px;height:100px"
             :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.teamImgurl" 
              alt="">
          </template>
        </el-table-column>
        <el-table-column prop="teamleader" label="队长姓名"></el-table-column>
        <el-table-column prop="releasetime" label="创建时间"></el-table-column>
        <el-table-column prop="signature" label="签名"></el-table-column>
        <!-- <el-table-column label="状态">
           <template slot-scope="scope">
             <div v-if="scope.row.state == 0">进行中</div>
            <div v-if="scope.row.state == 1">报名截止</div>
            <div v-if="scope.row.state == 2">活动结束</div>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="上线/下线">
          <template slot-scope="scope">
            <div v-if="scope.row.isWeb == 1">上线</div>
            <div v-else>下线</div>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="分店编号">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column> -->
      </el-table>
    </el-row>
  </div>
</template>

<script>
let that;
import {getEventMember} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      tableData:[],
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    goback(){
      this.$router.go(-1)
    },
    getTableList(){
      getEventMember({eventId:this.$route.query.id}).then((res)=>{
        console.log(res)
        if(res.msg == "success"){
            this.tableData = res.data
        }
        this.loading = false
      })
    }
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// gameIteminfo.vue?01315784